import React, { useState, useEffect, useCallback } from 'react';
import { IoIosCloseCircle } from 'react-icons/io';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import toast from 'react-hot-toast';
import { uploadImagecertifates } from '../../Redux/Actions/Action';
import {
    Box,
    Button,
    Switch,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Typography,
    Chip,
    CircularProgress,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from '@mui/material';
import { validateFile } from '../../utils/comman-function';
import { Autocomplete } from '@mui/material';

const REDIRECT_OPTIONS = [
    { label: 'Recharge Pack', value: 'recharge_pack' },
    { label: 'Connect Page', value: 'connect_page' },
    { label: 'Shastriji', value: 'shastriji' },
    { label: 'Services', value: 'services' },
    { label: 'Pooja Listing', value: 'pooja_listing' },
    { label: 'Pooja Details', value: 'pooja_details' },
    { label: 'Categories', value: 'categories' },
    // { label: 'Custom URL', value: 'custom' },
];

// Categories will be fetched dynamically

/* ─────────────────────────────────────────────
   Reusable Banner Card
   ───────────────────────────────────────────── */
function BannerCard({
    title,
    bannerIndex,
    bannerImage,
    isVisible,
    categoryId,
    redirectionFor,
    loading,
    onImageUpload,
    onRemoveImage,
    onVisibilityToggle,
    onCategoryChange,
    onRedirectionForChange,
    onDrop,
    onTitleChange,
    onDelete,
    categoryList = [],
    poojaList = [],
    poojaListLoading = false,
    onPoojaChange,
    onCustomUrlChange,
    poojaId,
    customUrl
}) {
    const [isDragging, setIsDragging] = useState(false);

    const handleDragOver = (e) => { e.preventDefault(); setIsDragging(true); };
    const handleDragLeave = (e) => { e.preventDefault(); setIsDragging(false); };
    const handleDropInternal = (e) => { e.preventDefault(); setIsDragging(false); onDrop(e); };

    return (
        <Box
            sx={{
                border: '1.5px solid #f0f0f0',
                borderRadius: '18px',
                padding: 0,
                backgroundColor: '#fff',
                overflow: 'hidden',
                transition: 'all 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                '&:hover': {
                    boxShadow: '0 12px 40px rgba(231,180,55,0.12)',
                    borderColor: '#E7B437',
                    transform: 'translateY(-2px)',
                },
            }}
        >
            {/* Card Header */}
            <Box
                sx={{
                    background: 'linear-gradient(135deg, #FFF9E6 0%, #FFF3CC 100%)',
                    padding: '16px 22px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    borderBottom: '1px solid #f5ecd0',
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2, flex: 1 }}>
                    <Box
                        sx={{
                            width: 32, height: 32, borderRadius: '9px',
                            background: 'linear-gradient(135deg, #E7B437, #d4a02e)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            fontSize: '14px', fontWeight: 800, color: '#fff',
                            boxShadow: '0 2px 8px rgba(231,180,55,0.35)',
                        }}
                    >
                        {bannerIndex}
                    </Box>
                    <Typography sx={{ fontSize: '15px', fontWeight: 700, color: '#333', flex: 1 }}>
                        Category {bannerIndex}
                    </Typography>
                </Box>
                {/* Status Badge */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Chip
                        label={isVisible ? '● Live' : '● Off'}
                        size="small"
                        sx={{
                            fontWeight: 700, fontSize: '11px', height: '24px',
                            backgroundColor: isVisible ? 'rgba(46,125,50,0.1)' : 'rgba(158,158,158,0.12)',
                            color: isVisible ? '#2e7d32' : '#999',
                            border: `1px solid ${isVisible ? 'rgba(46,125,50,0.25)' : 'rgba(158,158,158,0.25)'}`,
                        }}
                    />
                    {onDelete && (
                        <Button size="small" color="error" onClick={onDelete} sx={{ minWidth: 'auto', p: 0.5 }}>
                            <IoIosCloseCircle style={{ fontSize: '20px' }} />
                        </Button>
                    )}
                </Box>
            </Box>

            {/* Card Body */}
            <Box sx={{ padding: '20px 22px', flex: 1, display: 'flex', flexDirection: 'column' }}>
                {/* Image Upload */}
                {bannerImage ? (
                    <Box
                        sx={{
                            position: 'relative', borderRadius: '12px', overflow: 'hidden',
                            border: '2px solid #f0f0f0', transition: 'all 0.3s ease',
                            '&:hover': { borderColor: '#E7B437' },
                            '&:hover .replace-overlay': { opacity: 1 },
                        }}
                    >
                        <img
                            src={bannerImage} alt={title || "Banner Image"}
                            style={{ width: '100%', height: '180px', display: 'block', objectFit: 'cover' }}
                        />
                        <button
                            type="button" onClick={onRemoveImage}
                            style={{
                                position: 'absolute', top: '8px', right: '8px',
                                background: 'rgba(255,255,255,0.95)', border: 'none', borderRadius: '50%',
                                width: '30px', height: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center',
                                cursor: 'pointer', transition: 'all 0.2s ease', boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                            }}
                        >
                            <IoIosCloseCircle style={{ fontSize: '22px', color: '#d32f2f' }} />
                        </button>

                        <Box
                            className="replace-overlay"
                            sx={{
                                position: 'absolute', bottom: 0, left: 0, right: 0,
                                background: 'linear-gradient(transparent, rgba(0,0,0,0.65))',
                                padding: '24px 12px 10px', display: 'flex', justifyContent: 'center',
                                opacity: 0, transition: 'opacity 0.3s ease',
                            }}
                        >
                            <Button
                                component="label" variant="contained" size="small" disabled={loading}
                                sx={{
                                    borderRadius: '7px', textTransform: 'none', backgroundColor: '#E7B437',
                                    fontWeight: 600, fontSize: '12px', px: 2.5, py: 0.5,
                                    '&:hover': { backgroundColor: '#d4a02e' },
                                }}
                            >
                                {loading ? 'Uploading...' : 'Replace'}
                                <input type="file" hidden accept=".jpg,.png,.jpeg,.gif,.bmp,.webp,.svg" onChange={onImageUpload} />
                            </Button>
                        </Box>
                    </Box>
                ) : (
                    <Box
                        onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDropInternal}
                        sx={{
                            borderRadius: '12px',
                            border: `2px dashed ${isDragging ? '#E7B437' : '#d8d8d8'}`,
                            backgroundColor: isDragging ? '#fffef5' : '#fafafa',
                            padding: '32px 16px', transition: 'all 0.3s ease',
                            cursor: 'pointer', position: 'relative', textAlign: 'center',
                            '&:hover': { borderColor: '#E7B437', backgroundColor: '#fffef5' },
                        }}
                    >
                        {loading ? (
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                                <CircularProgress size={32} sx={{ color: '#E7B437' }} />
                                <Typography sx={{ fontSize: '13px', color: '#888', fontWeight: 500 }}>Uploading...</Typography>
                            </Box>
                        ) : (
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
                                <i className="fa fa-cloud-upload" aria-hidden="true" style={{ fontSize: '40px', color: '#E7B437', marginBottom: '4px' }}></i>
                                <Typography sx={{ fontSize: '14px', color: '#E7B437', fontWeight: 700 }}>Upload Image</Typography>
                                <Typography sx={{ fontSize: '11px', color: '#aaa' }}>Drag & drop or click • PNG, JPG, WEBP</Typography>
                            </Box>
                        )}
                        <input
                            type="file" accept=".jpg,.png,.jpeg,.gif,.bmp,.webp,.svg"
                            onChange={onImageUpload} disabled={loading}
                            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', opacity: 0, cursor: loading ? 'not-allowed' : 'pointer' }}
                        />
                    </Box>
                )}

                {/* Controls Row */}
                <Box sx={{ mt: 'auto', pt: 2.5, display: 'flex', flexDirection: 'column', gap: 2 }}>
                    
                    {/* Title Input */}
                    <Box
                        sx={{
                            border: '1px solid #f0f0f0', borderRadius: '10px', padding: '12px 14px',
                            backgroundColor: '#fafafa', transition: 'all 0.2s ease',
                            '&:hover': { borderColor: '#E7B437' },
                        }}
                    >
                        <Typography sx={{ fontSize: '11px', fontWeight: 600, color: '#888', textTransform: 'uppercase', letterSpacing: '0.4px', mb: 1 }}>
                            Title
                        </Typography>
                        <TextField
                            fullWidth
                            size="small"
                            placeholder="Enter Title..."
                            value={title}
                            onChange={(e) => onTitleChange(e.target.value)}
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '8px', backgroundColor: '#fff', fontSize: '13px',
                                    '& fieldset': { borderColor: '#e0e0e0' },
                                    '&:hover fieldset': { borderColor: '#E7B437' },
                                    '&.Mui-focused fieldset': { borderColor: '#E7B437' },
                                }
                            }}
                        />
                    </Box>
                    {/* Visibility Toggle */}
                    <Box
                        sx={{
                            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                            border: '1px solid #f0f0f0', borderRadius: '10px', padding: '10px 14px',
                            backgroundColor: '#fafafa', transition: 'all 0.2s ease',
                            '&:hover': { borderColor: '#E7B437' },
                        }}
                    >
                        <Box>
                            <Typography sx={{ fontSize: '12px', fontWeight: 600, color: '#555' }}>Show on App</Typography>
                            <Typography sx={{ fontSize: '10px', color: '#aaa' }}>
                                {isVisible ? 'Currently visible to users' : 'Hidden from users'}
                            </Typography>
                        </Box>
                        <Switch
                            checked={isVisible}
                            onChange={onVisibilityToggle}
                            size="small"
                            sx={{
                                '& .MuiSwitch-switchBase.Mui-checked': { color: '#E7B437' },
                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#E7B437' },
                            }}
                        />
                    </Box>

                    {/* Redirection For Dropdown */}
                    {/* 
                    <Box
                        sx={{
                            border: '1px solid #f0f0f0', borderRadius: '10px', padding: '12px 14px',
                            backgroundColor: '#fafafa', transition: 'all 0.2s ease',
                            '&:hover': { borderColor: '#E7B437' },
                        }}
                    >
                        <Typography sx={{ fontSize: '11px', fontWeight: 600, color: '#888', textTransform: 'uppercase', letterSpacing: '0.4px', mb: 1 }}>
                            Redirection For
                        </Typography>
                        <FormControl fullWidth size="small">
                            <Select
                                value={redirectionFor || 'recharge_pack'}
                                onChange={(e) => onRedirectionForChange(e.target.value)}
                                sx={{
                                    borderRadius: '8px', backgroundColor: '#fff', fontSize: '13px',
                                    '& .MuiOutlinedInput-notchedOutline': { borderColor: '#e0e0e0' },
                                    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#E7B437' },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#E7B437' },
                                }}
                            >
                                {REDIRECT_OPTIONS.map((opt) => (
                                    <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        {redirectionFor === 'custom' && (
                            <TextField
                                fullWidth
                                size="small"
                                placeholder="Enter Custom URL"
                                value={customUrl || ''}
                                onChange={(e) => onCustomUrlChange(e.target.value)}
                                sx={{
                                    mt: 2,
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '8px', backgroundColor: '#fff', fontSize: '13px',
                                        '& fieldset': { borderColor: '#e0e0e0' },
                                        '&:hover fieldset': { borderColor: '#E7B437' },
                                        '&.Mui-focused fieldset': { borderColor: '#E7B437' },
                                    }
                                }}
                            />
                        )}
                    </Box>
                    */}

                    {/* Category Dropdown (Conditional) */}
                    {/* 
                    {redirectionFor === 'categories' && (
                        <Box
                            sx={{
                                border: '1px solid #f0f0f0', borderRadius: '10px', padding: '12px 14px',
                                backgroundColor: '#fafafa', transition: 'all 0.2s ease', mt: 2,
                                '&:hover': { borderColor: '#E7B437' },
                            }}
                        >
                            <Typography sx={{ fontSize: '11px', fontWeight: 600, color: '#888', textTransform: 'uppercase', letterSpacing: '0.4px', mb: 1 }}>
                                Select Category
                            </Typography>
                            <FormControl fullWidth size="small">
                                <Select
                                    displayEmpty
                                    value={categoryId || ''}
                                    onChange={(e) => onCategoryChange(e.target.value)}
                                    sx={{
                                        borderRadius: '8px', backgroundColor: '#fff', fontSize: '13px',
                                        '& .MuiOutlinedInput-notchedOutline': { borderColor: '#e0e0e0' },
                                        '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#E7B437' },
                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#E7B437' },
                                    }}
                                >
                                    <MenuItem value="" disabled>Select a Category</MenuItem>
                                    {categoryList.map((cat) => (
                                        <MenuItem key={cat._id} value={cat._id}>{cat.categoryName}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
                    )}
                    */}

                    {/* Pooja Selector (shown when pooja_details is selected) */}
                    {/* 
                    {redirectionFor === 'pooja_details' && (
                        <Box
                            sx={{
                                border: '1px solid #f0e0a0',
                                borderRadius: '10px',
                                padding: '12px 14px',
                                backgroundColor: '#fffef5',
                                transition: 'all 0.2s ease',
                                '&:hover': { borderColor: '#E7B437' },
                                mt: 2
                            }}
                        >
                            <Typography sx={{ fontSize: '11px', fontWeight: 600, color: '#888', textTransform: 'uppercase', letterSpacing: '0.4px', mb: 1 }}>
                                Select Pooja
                            </Typography>
                            <Autocomplete
                                size="small"
                                options={poojaList}
                                loading={poojaListLoading}
                                getOptionLabel={(opt) => opt.name || ''}
                                value={poojaList.find((p) => p._id === poojaId) || null}
                                onChange={(_, newVal) => onPoojaChange(newVal?._id || '')}
                                isOptionEqualToValue={(opt, val) => opt._id === val._id}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Search and select a pooja..."
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <>
                                                    {poojaListLoading ? <CircularProgress size={16} sx={{ color: '#E7B437' }} /> : null}
                                                    {params.InputProps.endAdornment}
                                                </>
                                            ),
                                        }}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '8px', backgroundColor: '#fff', fontSize: '13px',
                                                '& fieldset': { borderColor: '#e0e0e0' },
                                                '&:hover fieldset': { borderColor: '#E7B437' },
                                                '&.Mui-focused fieldset': { borderColor: '#E7B437' },
                                            }
                                        }}
                                    />
                                )}
                                renderOption={(props, option) => (
                                    <li {...props} key={option._id}>
                                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                            <Typography sx={{ fontSize: '13px', fontWeight: 600 }}>{option.name}</Typography>
                                            {option.basePrice && (
                                                <Typography sx={{ fontSize: '11px', color: '#999' }}>₹{option.basePrice}</Typography>
                                            )}
                                        </Box>
                                    </li>
                                )}
                                noOptionsText="No poojas found"
                            />
                        </Box>
                    )}
                    */}
                </Box>
            </Box>
        </Box>
    );
}

/* ─────────────────────────────────────────────
   Main Pooja Category Redirection Page
   ───────────────────────────────────────────── */
function PoojaCategoryRedirection() {
    const dispatch = useDispatch();

    const [mainTitle, setMainTitle] = useState('');
    const [status, setStatus] = useState(false);
    const [configId, setConfigId] = useState(null);
    const [items, setItems] = useState([]);
    const [categoryList, setCategoryList] = useState([]);
    const [fetching, setFetching] = useState(true);
    const [saving, setSaving] = useState(false);
    const [loadingMap, setLoadingMap] = useState({});

    const [poojaList, setPoojaList] = useState([]);
    const [poojaListLoading, setPoojaListLoading] = useState(false);

    const [deleteDialog, setDeleteDialog] = useState({ open: false, itemId: null });

    // Fetch Poojas
    const fetchPoojas = useCallback(async () => {
        try {
            setPoojaListLoading(true);
            const token = localStorage.getItem('astroVani-admin-token');
            const res = await axios.get(`${process.env.REACT_APP_BASEURL}/admin/pooja?page=1&limit=500`, { 
                headers: { Authorization: token } 
            });
            const data = res.data;
            const list = Array.isArray(data?.data?.data) ? data.data.data : Array.isArray(data?.data) ? data.data : Array.isArray(data) ? data : [];
            setPoojaList(list);
        } catch (err) {
            console.error('Error fetching pooja list:', err);
        } finally {
            setPoojaListLoading(false);
        }
    }, []);

    // Fetch Categories
    const fetchCategories = useCallback(async () => {
        try {
            const token = localStorage.getItem('astroVani-admin-token');
            const res = await axios.get(`${process.env.REACT_APP_BASEURL}/admin/category?page=1&limit=500`, { 
                headers: { Authorization: token } 
            });
            if (res.data?.success) {
                const data = res.data.data?.data || res.data.data || [];
                setCategoryList(data);
            }
        } catch (err) {
            console.error('Error fetching pooja categories:', err);
        }
    }, []);

    // Fetch existing data
    const fetchData = useCallback(async () => {
        try {
            const token = localStorage.getItem('astroVani-admin-token');
            if (!token) return;

            // API endpoint as per documentation
            const response = await axios.get(
                `${process.env.REACT_APP_BASEURL}/admin/poojaTrail?page=1&limit=500`,
                { headers: { Authorization: token } }
            );

            if (response.data?.success) {
                let data = response.data.data;
                let fetchedItems = [];
                let parentId = null;
                
                if (Array.isArray(data) && data.length > 0 && typeof data[0] === 'object' && 'items' in data[0]) {
                    parentId = data[0]._id;
                    setMainTitle(data[0].mainTitle || '');
                    setStatus(data[0].status ?? true);
                    fetchedItems = data[0].items || [];
                } else if (data && typeof data === 'object' && !Array.isArray(data) && data.items) {
                    parentId = data._id;
                    setMainTitle(data.mainTitle || '');
                    setStatus(data.status ?? true);
                    fetchedItems = data.items;
                } else if (data && typeof data === 'object' && !Array.isArray(data) && data.data) {
                    if (data.mainTitle !== undefined) setMainTitle(data.mainTitle);
                    if (data.status !== undefined) setStatus(data.status);
                    fetchedItems = data.data;
                } else if (Array.isArray(data)) {
                    fetchedItems = data;
                }

                if (parentId) setConfigId(parentId);

                setItems(fetchedItems.map((item, index) => ({
                    id: item._id || `temp_${index}`,
                    title: item.title || '',
                    image: item.image || null,
                    isActive: item.isActive ?? false,
                    redirectionFor: item.redirectionFor || 'recharge_pack',
                    categoryId: typeof item.categoryId === 'object' ? item.categoryId?._id : (item.categoryId || ''),
                    poojaId: item.poojaId || '',
                    customUrl: item.redirectionFor === 'custom' && item.redirectionUrl ? item.redirectionUrl : ''
                })));
            }
        } catch (err) {
            console.error('Error fetching pooja category redirections:', err);
            // Fallback for UI if API doesn't exist yet
            setItems(prev => {
                if (prev.length === 0) {
                    return [{
                        id: `temp_1`,
                        title: '',
                        image: null,
                        isActive: false,
                        redirectionFor: 'recharge_pack',
                        categoryId: '',
                        poojaId: '',
                        customUrl: ''
                    }];
                }
                return prev;
            });
        } finally {
            setFetching(false);
        }
    }, []);

    useEffect(() => {
        fetchData();
        fetchCategories();
        fetchPoojas();
    }, [fetchData, fetchCategories, fetchPoojas]);

    const handleItemChange = (id, field, value) => {
        setItems(prev => prev.map(item => item.id === id ? { ...item, [field]: value } : item));
    };

    const handleImageUpload = async (event, id) => {
        const file = event.target.files?.[0];
        if (!file) return;
        if (!file.type.startsWith('image/')) { toast.error('Please select a valid image file.'); return; }
        if (!validateFile(file, 'image')) return;

        setLoadingMap(prev => ({ ...prev, [id]: true }));
        try {
            const uploadedUrl = await dispatch(uploadImagecertifates(file));
            if (uploadedUrl) {
                handleItemChange(id, 'image', uploadedUrl.toString());
                toast.success('Image uploaded!');
            }
        } catch (err) {
            console.error('Upload failed:', err);
            toast.error('Error uploading image.');
        } finally {
            setLoadingMap(prev => ({ ...prev, [id]: false }));
            event.target.value = '';
        }
    };

    const handleDrop = async (e, id) => {
        const file = e.dataTransfer.files?.[0];
        if (!file) return;
        if (!file.type.startsWith('image/')) { toast.error('Please drop a valid image file.'); return; }
        if (!validateFile(file, 'image')) return;

        setLoadingMap(prev => ({ ...prev, [id]: true }));
        try {
            const uploadedUrl = await dispatch(uploadImagecertifates(file));
            if (uploadedUrl) {
                handleItemChange(id, 'image', uploadedUrl.toString());
                toast.success('Image uploaded!');
            }
        } catch (err) {
            console.error('Upload failed:', err);
            toast.error('Error uploading image.');
        } finally {
            setLoadingMap(prev => ({ ...prev, [id]: false }));
        }
    };

    const addNewItem = () => {
        if (items.length >= 2) {
            toast.warning('You can only add up to 2 items.');
            return;
        }
        setItems(prev => [
            ...prev,
            {
                id: `temp_${Date.now()}`,
                title: '',
                image: null,
                isActive: true,
                redirectionFor: 'recharge_pack',
                categoryId: '',
                poojaId: '',
                customUrl: ''
            }
        ]);
    };

    const removeItem = async () => {
        const id = deleteDialog.itemId;
        if (!id) return;
        setItems(prev => prev.filter(i => i.id !== id));
        toast.success('Removed successfully! Click "Save Changes" to apply.');
        setDeleteDialog({ open: false, itemId: null });
    };

    const updateToggle = async (id, isActive) => {
        handleItemChange(id, 'isActive', isActive);
        
        if (configId) {
            try {
                const token = localStorage.getItem('astroVani-admin-token');
                
                const updatedItems = items.map(item => {
                    const currentIsActive = item.id === id ? isActive : item.isActive;
                    const base = {
                        title: item.title,
                        image: item.image,
                        isActive: currentIsActive,
                        redirectionFor: item.redirectionFor,
                        categoryId: item.redirectionFor === 'categories' ? item.categoryId : undefined
                    };
                    if (item.redirectionFor === 'pooja_details' && item.poojaId) {
                        base.poojaId = item.poojaId;
                        base.redirectionUrl = `/pooja-details/${item.poojaId}`;
                    } else if (item.redirectionFor === 'custom' && item.customUrl) {
                        base.redirectionUrl = item.customUrl;
                    }
                    return base;
                });
                
                const payload = {
                    mainTitle: mainTitle,
                    status: status,
                    items: updatedItems
                };
                
                await axios.patch(
                    `${process.env.REACT_APP_BASEURL}/admin/poojaTrail/${configId}`,
                    payload,
                    { headers: { Authorization: token, 'Content-Type': 'application/json' } }
                );
                
                toast.success(`Banner ${isActive ? 'enabled' : 'disabled'} successfully!`);
            } catch (err) {
                console.error('Toggle error:', err);
                toast.error('Failed to update banner status dynamically.');
                handleItemChange(id, 'isActive', !isActive);
            }
        } else {
            toast.success(`Status updated locally. Click "Save Changes" to apply.`);
        }
    };

    const handleSave = async () => {
        // Validation
        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            if (!item.title?.trim() || !item.image) {
                toast.error(`Please fill all fields (Title, Image) for Category ${i + 1}`);
                return;
            }
            if (item.redirectionFor === 'categories' && !item.categoryId) {
                toast.error(`Please select a Category for Category ${i + 1}`);
                return;
            }
        }

        setSaving(true);
        try {
            const token = localStorage.getItem('astroVani-admin-token');
            if (!token) { toast.error('Authentication token not found.'); setSaving(false); return; }

            const payload = {
                mainTitle: mainTitle,
                status: status,
                items: items.map(item => {
                    const base = {
                        title: item.title,
                        image: item.image,
                        isActive: item.isActive,
                        redirectionFor: item.redirectionFor,
                        categoryId: item.redirectionFor === 'categories' ? item.categoryId : undefined
                    };
                    if (item.redirectionFor === 'pooja_details' && item.poojaId) {
                        base.poojaId = item.poojaId;
                        base.redirectionUrl = `/pooja-details/${item.poojaId}`;
                    } else if (item.redirectionFor === 'custom' && item.customUrl) {
                        base.redirectionUrl = item.customUrl;
                    }
                    return base;
                })
            };

            if (configId) {
                await axios.patch(
                    `${process.env.REACT_APP_BASEURL}/admin/poojaTrail/${configId}`,
                    payload,
                    { headers: { Authorization: token, 'Content-Type': 'application/json' } }
                );
            } else {
                await axios.post(
                    `${process.env.REACT_APP_BASEURL}/admin/poojaTrail`,
                    payload,
                    { headers: { Authorization: token, 'Content-Type': 'application/json' } }
                );
            }

            toast.success('Pooja Category Redirections updated successfully!');
            fetchData(); // Refresh to get real IDs for new items
        } catch (err) {
            console.error('Save error:', err);
            toast.error(err?.response?.data?.message || 'Error updating data.');
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="container-xxl">
            {/* Header */}
            <Box
                sx={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    flexWrap: 'wrap', gap: 2, py: 2.5, mb: 1,
                }}
            >
                <Box>
                    <Typography sx={{ fontSize: '22px', fontWeight: 800, color: '#222', letterSpacing: '-0.3px' }}>
                        Pooja Category Redirection
                    </Typography>
                    <Typography sx={{ fontSize: '13px', color: '#999', mt: 0.3 }}>
                        Manage redirections with Title, Image, and Redirect configuration.
                    </Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 2 }}>
                    <Button
                        variant="outlined"
                        onClick={addNewItem}
                        disabled={items.length >= 2}
                        sx={{
                            borderRadius: '10px', textTransform: 'none', px: 3, py: 1.1,
                            fontSize: '14px', fontWeight: 600,
                            color: '#E7B437', borderColor: '#E7B437',
                            '&:hover': { backgroundColor: 'rgba(231,180,55,0.05)', borderColor: '#d4a02e' }
                        }}
                    >
                        + Add Category
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleSave}
                        disabled={saving}
                        startIcon={saving ? <CircularProgress size={16} sx={{ color: '#fff' }} /> : null}
                        sx={{
                            borderRadius: '10px', textTransform: 'none', px: 4, py: 1.1,
                            fontSize: '14px', fontWeight: 700,
                            background: 'linear-gradient(135deg, #E7B437, #d4a02e)',
                            color: '#fff',
                            boxShadow: '0 4px 16px rgba(231,180,55,0.3)',
                            transition: 'all 0.25s ease',
                            '&:hover': {
                                background: 'linear-gradient(135deg, #d4a02e, #c4920e)',
                                boxShadow: '0 6px 22px rgba(231,180,55,0.4)',
                                transform: 'translateY(-1px)',
                            },
                        }}
                    >
                        {saving ? 'Saving...' : 'Save Changes'}
                    </Button>
                </Box>
            </Box>

            {/* Main Title and Status */}
            <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 3, flexWrap: 'wrap', justifyContent: 'space-between' }}>
                <Box sx={{ flex: 1, maxWidth: '500px' }}>
                    <Typography sx={{ fontSize: '12px', fontWeight: 600, color: '#555', mb: 1, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                        Main Title
                    </Typography>
                    <TextField
                        fullWidth
                        size="small"
                        placeholder="Enter Main Title (e.g. Festivals Special)"
                        value={mainTitle}
                        onChange={(e) => setMainTitle(e.target.value)}
                        sx={{
                            backgroundColor: '#fff',
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '8px',
                                '& fieldset': { borderColor: '#e0e0e0' },
                                '&:hover fieldset': { borderColor: '#E7B437' },
                                '&.Mui-focused fieldset': { borderColor: '#E7B437' },
                            }
                        }}
                    />
                </Box>
                
                <Box sx={{ mt: { xs: 0, sm: '19px' } }}>
                    <Box display="flex" alignItems="center" gap={1} sx={{ bgcolor: '#fff', px: 2, py: 0.5, borderRadius: '8px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', border: '1px solid #e0e0e0' }}>
                        <Typography variant="body2" fontWeight={600} color={status ? 'success.main' : 'text.secondary'}>
                            Status: {status ? 'Enabled' : 'Disabled'}
                        </Typography>
                        <Switch
                            checked={status}
                            onChange={(e) => setStatus(e.target.checked)}
                            color="success"
                        />
                    </Box>
                </Box>
            </Box>

            {/* Grid */}
            {fetching ? (
                <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 3 }}>
                    {[1, 2, 3].map((i) => (
                        <Box key={i} sx={{ height: 420, borderRadius: '18px', backgroundColor: '#fff', padding: 2 }}>
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                <CircularProgress sx={{ color: '#E7B437' }} />
                            </Box>
                        </Box>
                    ))}
                </Box>
            ) : (
                <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr', lg: '1fr 1fr 1fr' }, gap: 3, mb: 4 }}>
                    {items.map((item, index) => (
                        <Box key={item.id}>
                            <BannerCard
                                title={item.title}
                                bannerIndex={index + 1}
                                bannerImage={item.image}
                                isVisible={item.isActive}
                                categoryId={item.categoryId}
                                poojaId={item.poojaId}
                                customUrl={item.customUrl}
                                redirectionFor={item.redirectionFor}
                                loading={loadingMap[item.id] || false}
                                categoryList={categoryList}
                                poojaList={poojaList}
                                poojaListLoading={poojaListLoading}
                                onTitleChange={(val) => handleItemChange(item.id, 'title', val)}
                                onImageUpload={(e) => handleImageUpload(e, item.id)}
                                onRemoveImage={() => handleItemChange(item.id, 'image', null)}
                                onVisibilityToggle={(e) => updateToggle(item.id, e.target.checked)}
                                onCategoryChange={(val) => handleItemChange(item.id, 'categoryId', val)}
                                onRedirectionForChange={(val) => handleItemChange(item.id, 'redirectionFor', val)}
                                onPoojaChange={(val) => handleItemChange(item.id, 'poojaId', val)}
                                onCustomUrlChange={(val) => handleItemChange(item.id, 'customUrl', val)}
                                onDrop={(e) => handleDrop(e, item.id)}
                                onDelete={() => setDeleteDialog({ open: true, itemId: item.id })}
                            />
                        </Box>
                    ))}
                </Box>
            )}
            
            {items.length === 0 && !fetching && (
                <Box sx={{ textAlign: 'center', py: 10 }}>
                    <Typography variant="h6" color="textSecondary">No Pooja Category Redirections Found</Typography>
                    <Button variant="outlined" onClick={addNewItem} sx={{ mt: 2 }}>Add First Category</Button>
                </Box>
            )}

            {/* Delete Confirmation Dialog */}
            <Dialog 
                open={deleteDialog.open} 
                onClose={() => setDeleteDialog({ open: false, itemId: null })}
                PaperProps={{
                    sx: { borderRadius: '16px', padding: '8px', minWidth: '320px' }
                }}
            >
                <DialogTitle sx={{ fontWeight: 800, color: '#333', fontSize: '18px' }}>
                    Confirm Deletion
                </DialogTitle>
                <DialogContent>
                    <Typography sx={{ color: '#666', fontSize: '14px' }}>
                        Are you sure you want to delete this category? This action cannot be undone.
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ padding: '16px 24px' }}>
                    <Button 
                        onClick={() => setDeleteDialog({ open: false, itemId: null })}
                        sx={{ color: '#888', textTransform: 'none', fontWeight: 700 }}
                    >
                        Cancel
                    </Button>
                    <Button 
                        onClick={removeItem}
                        variant="contained"
                        sx={{ 
                            textTransform: 'none', fontWeight: 700, borderRadius: '8px', boxShadow: 'none',
                            backgroundColor: '#d32f2f', '&:hover': { backgroundColor: '#b71c1c' }
                        }}
                    >
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>

        </div>
    );
}

export default PoojaCategoryRedirection;
